import type { SeriesRunVisit } from '../../api/series.types'

type DatedVisit = SeriesRunVisit & { date: string; appointmentId: number }

const isBookedWithDate = (visit: SeriesRunVisit): visit is DatedVisit =>
  visit.date !== null && visit.appointmentId !== null

const byDate = (a: DatedVisit, b: DatedVisit): number => a.date.localeCompare(b.date)

// The next scheduled visit from the site's today, else the latest booked one; dates compare as strings.
export const pickDetailsVisit = (
  visits: SeriesRunVisit[],
  today: string,
): SeriesRunVisit | null => {
  const booked = visits.filter(isBookedWithDate)
  const upcoming = booked
    .filter((visit) => visit.bucket === 'scheduled' && visit.date >= today)
    .sort(byDate)
  if (upcoming.length > 0) return upcoming[0]
  const latest = [...booked].sort(byDate).at(-1)
  return latest ?? null
}
